var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgCamera(props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 105 93",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M92.885 12.13H78.89L72.011 1.8A4.04 4.04 0 0068.654 0H36.346a4.034 4.034 0 00-3.357 1.8l-6.885 10.33H12.115a12.108 12.108 0 00-8.566 3.553A12.138 12.138 0 000 24.261V80.87c0 3.217 1.276 6.302 3.549 8.577A12.108 12.108 0 0012.115 93h80.77c3.213 0 6.294-1.278 8.566-3.553A12.135 12.135 0 00105 80.87V24.26c0-3.216-1.276-6.302-3.549-8.577a12.106 12.106 0 00-8.566-3.553zM70.673 50.543c0 3.6-1.066 7.117-3.063 10.11a18.178 18.178 0 01-8.155 6.701A18.152 18.152 0 0139.65 63.41a18.217 18.217 0 01-3.94-19.83 18.19 18.19 0 016.694-8.166 18.157 18.157 0 0122.946 2.263 18.207 18.207 0 015.323 12.867z",
    fill: "#000"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCamera);
export default ForwardRef;